import * as R from 'ramda';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { getFilterByType } from 'utilities';

import * as validators from 'utilities/validators';

import ModalContentComponent from './Component';

const ModalContentContainer = ({ parameter, onAddFilter }) => {
  const [filterType, setFilterType] = useState(parameter.filterType);
  const [selectError, setSelectError] = useState('');

  const handleFilterTypeChange = type => {
    setFilterType(type);
    setSelectError('');
  };

  const handleAddFilterClick = filterOptions => {
    if (!filterType) {
      setSelectError('Can not be empty!');
      return;
    }

    const filter = (getFilterByType(filterType, filterOptions));
    onAddFilter({ filterOptions, filterType, filter });
    setSelectError('');
  };

  const getFieldValidator = () => R.contains(filterType, ['LT', 'LTE', 'GT', 'GTE', 'BTW'])
    ? validators.isRequiredNumber
    : validators.isRequired;

  return (
    <ModalContentComponent
      parameter={parameter}
      filterType={filterType}
      selectError={selectError}
      onSubmit={handleAddFilterClick}
      fieldValidator={getFieldValidator()}
      onFilterTypeChange={handleFilterTypeChange}
      initialValues={parameter.filterOptions}
    />
  );
};


ModalContentContainer.propTypes = {
  parameter: PropTypes.object.isRequired,
  onAddFilter: PropTypes.func.isRequired
};

export default ModalContentContainer;
